import { render, staticRenderFns } from "./MyBonus.vue?vue&type=template&id=850bba6c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1DesktopProfilesMyBonus: require('/app/components/Theme1/Desktop/Profiles/MyBonus.vue').default,Theme1ProfileLayout: require('/app/components/Theme1/ProfileLayout.vue').default})
